import { MicroBadge } from 'components/MicroBadge';
import { VendorFactor } from './types';
import { Icon } from 'components/Icon';

import { PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';
import { months } from 'options';
import type { RateChartData } from './RateChart';
import { lazy } from 'react';
export const RateChart = lazy(() => import('./RateChart'));

const createMonthData = (rates: Record<string, string>): RateChartData =>
  months.map((label, idx) => {
    const key = `_${idx + 1}`;
    return { label: label.substring(0, 3), value: key in rates ? Number.parseFloat(rates[key]) : 0 };
  });

const createWeekData = (rates: Record<string, string>): RateChartData =>
  Array.from(Array(52).keys()).map((_, idx) => {
    const key = `_${idx + 1}`;
    return { label: `${idx + 1}`, value: key in rates ? Number.parseFloat(rates[key]) : 0 };
  });

export function FactorRateBadge({
  factor: { kind, form, rate, rates },
  portal = undefined,
}: {
  factor: VendorFactor;
  portal?: true | string;
}) {
  const symbol = form === 'PERCENTAGE' ? '%' : '';

  switch (kind) {
    case 'CONSTANT':
      return (
        <MicroBadge>
          {rate}
          {symbol}
        </MicroBadge>
      );
    case 'MONTHLY':
    case 'WEEKLY': {
      const numericValues = Object.values(rates).map((value) => Number.parseFloat(value));
      const minValue = Math.min(...numericValues);
      const maxValue = Math.max(...numericValues);

      return (
        <MicroBadge>
          <PopoverRoot>
            <PopoverTrigger openOnHover>
              <span role="button" aria-label="Rate chart">
                <Icon icon="chart-simple" /> {minValue}-{maxValue}
                {symbol}
              </span>
            </PopoverTrigger>
            <PopoverPopup portal={portal}>
              <RateChart data={kind === 'MONTHLY' ? createMonthData(rates) : createWeekData(rates)} />
            </PopoverPopup>
          </PopoverRoot>
        </MicroBadge>
      );
    }
    default:
      throw new Error(`Unknown kind ${kind}`);
  }
}
